import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: 'Help with Paying for College' },
	{
		name: 'description',
		content: 'Help with Paying for College',
	},
]

export default function Component() {
	return (
		<>
			<h1 className="py-3 text-4xl font-black">Help with Paying for College</h1>
			<blockquote>
				"It is the little things upon which life turns that make the big
				difference in our lives...
				<br />
				There can be no doubt, none whatever, that education pays. Do not
				short-circuit your lives. If you do so, you will pay for it over and
				over and over again."
				<br />
				-Gordon B Hinckley
			</blockquote>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Education is important. Everyone should aim to be a lifelong learner.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				We have partnered with{' '}
				<a
					href="https://www.collegeassistanceplus.com/"
					target="_blank"
					rel="noopener noreferrer"
				>
					College Assistance Plus (opens in a new tab)
				</a>{' '}
				to hold educational meetings to help our friends and clients to be
				financially well-prepared for higher education. They offer many
				services:
			</p>
			<h2 className="p-4 text-2xl font-semibold">Preparing for College</h2>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				There is a lot that can and should be done when preparing for higher
				education, including:
			</p>
			<ul>
				<li>Selecting a Career Path</li>
				<li>Choosing a Major</li>
				<li>Standardized Testing - SAT/ACT </li>
				<li>Picking a College or University</li>
				<li>Interviewing</li>
				<li>Writing Essays</li>
				<li>Applying for Merit- and Needs-based Financial Aid</li>
			</ul>
			<h2 className="p-4 text-2xl font-semibold">Throughout College</h2>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Life changes can trigger a need to re-evaluate and change direction.
				Family circumstances or health can change in a heartbeat and can make it
				difficult to continue on an intended path. Reach out for help or to get
				your questions answered. College Assistance Plus can help with ongoing
				financial decisions with paying for college.
			</p>
			<h2 className="p-4 text-2xl font-semibold">After College</h2>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Technology has enabled College Assistance Plus to offer help to
				graduates who want to make the most of their career path.{' '}
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Find out more by visiting{' '}
				<a
					href="https://www.collegeassistanceplus.com/"
					target="_blank"
					rel="noopener noreferrer"
				>
					https://www.collegeassistanceplus.com/ (opens in a new tab)
				</a>
				.
			</p>
		</>
	)
}
